import Highcharts from 'highcharts';
import { filterByCategory } from '../ranking-sm/data'

export function getClampsData() {
    const categories = [
        'Blokady: liczba',
        'Etaty: liczba strażników',
        'Mandaty: liczba wystawionych',
        'Liczba mieszkańców'
    ];
    const data = filterByCategory(categories);

    const validData = data.filter(sm =>
        (sm['Etaty: liczba strażników'] || 0) > 0
    );

    validData.forEach(sm => {
        sm.clampsPerGuardMonthly = Math.round(((sm['Blokady: liczba'] || 0) / sm['Etaty: liczba strażników'] / 12) * 100) / 100;
        sm.clampsPer1000Fines = Math.round((sm['Blokady: liczba'] / sm['Mandaty: liczba wystawionych']) * 1000);
    });

    return validData.sort((a, b) => b.clampsPerGuardMonthly - a.clampsPerGuardMonthly);
}

/**
 * @param {string} id
 */
export default function chartClamps(id) {
    if (!document.getElementById(id)) return;

    const cityData = getClampsData();
    const categories = cityData.map(item => item.city);
    const clampsRatio = cityData.map(item => item.clampsPerGuardMonthly);

    Highcharts.chart(id, {
        chart: { type: 'bar', backgroundColor: 'transparent' },
        title: { text: 'Monthly wheel clamps per guard' },
        xAxis: {
            categories: categories,
            title: { text: null },
            labels: { style: { fontSize: '14px' } }
        },
        yAxis: {
            min: 0,
            title: { text: 'Number of clamps' }
        },
        tooltip: {
            shared: true,
            pointFormat: '<b>{point.y}</b> clamps per guard per month'
        },
        plotOptions: {
            bar: {
                dataLabels: { enabled: true, format: '{point.y:.1f}' },
                borderRadius: 4
            }
        },
        legend: { enabled: false },
        credits: { enabled: false },
        series: [{
            name: 'Clamps per guard',
            data: clampsRatio,
            color: '#e67e22'
        }]
    });
}
